
import { Product } from './types';

export const INITIAL_PRODUCTS: Product[] = [
  {
    id: 'cyme-camel',
    name: 'Polène Cyme — Camel',
    price: 250000,
    description: 'Cuir de veau grainé, coloris Camel iconique.',
    image: 'https://lltsrtityvwsvhbkzdll.supabase.co/storage/v1/object/sign/images/polene/cyme/packshot-front_cyme-camel-grain.webp?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9jZjZkNmYxNS02MDgzLTQwOWQtOTI0ZC03YjhjODQxOWUwNDMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvcG9sZW5lL2N5bWUvcGFja3Nob3QtZnJvbnRfY3ltZS1jYW1lbC1ncmFpbi53ZWJwIiwiaWF0IjoxNzY4OTI0NzM2LCJleHAiOjE4MzE5OTY3MzZ9.RWj0xUZTiiPjb3vkVztJDC5uIKAI_87TZtk6yqAR7ro',
    hoverImage: 'https://lltsrtityvwsvhbkzdll.supabase.co/storage/v1/object/sign/images/polene/cyme/packshot-turn_cyme-camel-grain.webp?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9jZjZkNmYxNS02MDgzLTQwOWQtOTI0ZC03YjhjODQxOWUwNDMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvcG9sZW5lL2N5bWUvcGFja3Nob3QtdHVybl9jeW1lLWNhbWVsLWdyYWluLndlYnAiLCJpYXQiOjE3Njg5MjQ3NjUsImV4cCI6MTgzMTk5Njc2NX0.0FLBmiQRsQ6Rj44d-LX_TOPDCK1cs_-XPLo9PkLOOGk',
    category: 'Polène',
    label: 'Best-seller',
    isOutOfStock: false,
    // Add missing stock property
    stock: 10
  },
  {
    id: 'cyme-canvas',
    name: 'Polène Cyme — Toile & Cognac',
    price: 210000,
    originalPrice: 245000,
    description: 'Édition estivale en toile de coton et finitions cuir.',
    image: 'https://lltsrtityvwsvhbkzdll.supabase.co/storage/v1/object/sign/images/polene/cyme/packshot-front_cyme-cognac-tissu.webp?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9jZjZkNmYxNS02MDgzLTQwOWQtOTI0ZC03YjhjODQxOWUwNDMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvcG9sZW5lL2N5bWUvcGFja3Nob3QtZnJvbnRfY3ltZS1jb2duYWMtdGlzc3Uud2VicCIsImlhdCI6MTc2ODkyNDc5NywiZXhwIjoxODMxOTk2Nzk3fQ.7KgyP4X89bhegX9ibOnFMr1YryeLs70kx4pkW4_uAJU',
    hoverImage: 'https://lltsrtityvwsvhbkzdll.supabase.co/storage/v1/object/sign/images/polene/cyme/packshot-turn_cyme-cognac-tissu.webp?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9jZjZkNmYxNS02MDgzLTQwOWQtOTI0ZC03YjhjODQxOWUwNDMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvcG9sZW5lL2N5bWUvcGFja3Nob3QtdHVybl9jeW1lLWNvZ25hYy10aXNzdS53ZWJwIiwiaWF0IjoxNzY4OTI0ODI5LCJleHAiOjE4MzE5OTY4Mjl9.t68tLkODFNGBeHer7k4YFnkyjIQUmhH_zBOhGvEkEDQ',
    category: 'Polène',
    label: 'Édition Limitée',
    isOutOfStock: false,
    // Add missing stock property
    stock: 5
  }
];

export const INSTAGRAM_POSTS = [
  {
    url: 'https://www.instagram.com/p/DRu9YMlDAvN/',
    image: 'https://lltsrtityvwsvhbkzdll.supabase.co/storage/v1/object/sign/images/insta_preview/polene_prev.jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9jZjZkNmYxNS02MDgzLTQwOWQtOTI0ZC03YjhjODQxOWUwNDMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvaW5zdGFfcHJldmlldy9wb2xlbmVfcHJldi5qcGVnIiwiaWF0IjoxNzY4OTI0NTEyLCJleHAiOjE4MzE5OTY1MTJ9.CvoOyvXCKRnXnAfhGgZIZYV-hwpoKfhgGyvm9bOFFeM'
  },
  {
    url: 'https://www.instagram.com/p/DPSGTwcDHS6/',
    image: 'https://lltsrtityvwsvhbkzdll.supabase.co/storage/v1/object/sign/images/insta_preview/gucci_prev.jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9jZjZkNmYxNS02MDgzLTQwOWQtOTI0ZC03YjhjODQxOWUwNDMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvaW5zdGFfcHJldmlldy9ndWNjaV9wcmV2LmpwZWciLCJpYXQiOjE3Njg5MjQ1NTksImV4cCI6MTgzMTk5NjU1OX0.tWqm2SF3UftS8iyFGVpZXy_y0is2c36p4GDoZgsKcVs'
  },
  {
    url: 'https://www.instagram.com/p/DSnYuMxjJNo/',
    image: 'https://lltsrtityvwsvhbkzdll.supabase.co/storage/v1/object/sign/images/insta_preview/newco_coach.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9jZjZkNmYxNS02MDgzLTQwOWQtOTI0ZC03YjhjODQxOWUwNDMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvaW5zdGFfcHJldmlldy9uZXdjb19jb2FjaC5wbmciLCJpYXQiOjE3Njg5MjQ2MTcsImV4cCI6MTgzMTk5NjYxN30.uS4UzVxSoNgumG9vPD9yljfu-ibEG4Y_jpPVe9M82pc'
  },
  {
    url: 'https://www.instagram.com/p/DRsd52DjE4g/',
    image: 'https://lltsrtityvwsvhbkzdll.supabase.co/storage/v1/object/sign/images/insta_preview/zara_prev.jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9jZjZkNmYxNS02MDgzLTQwOWQtOTI0ZC03YjhjODQxOWUwNDMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvaW5zdGFfcHJldmlldy96YXJhX3ByZXYuanBlZyIsImlhdCI6MTc2ODkyNDY1MCwiZXhwIjoxODMxOTk2NjUwfQ.6cXuhBjmXqX3IvW3Ikh9Zoqrwh3NhaRDHS1tnURTO6U'
  }
];

export const formatPrice = (price: number) => {
  return price.toLocaleString('fr-FR') + ' FCFA';
};
